export const TID = {
    // Auth
    loginEmail: 'login-email-input',
    loginPassword: 'login-password-input',
    loginSubmit: 'login-submit-btn',
    logoutBtn: 'logout-btn',
    // Layout
    sidebar: 'app-sidebar',
    sidebarNav: 'sidebar-nav',
    navDashboard: 'nav-dashboard',
    navDids: 'nav-dids',
    navExtensions: 'nav-extensions',
    navTrunks: 'nav-trunks',
    navCallFlows: 'nav-callflows',
    navIvr: 'nav-ivr',
    navRingGroups: 'nav-ringgroups',
    navCallLogs: 'nav-calllogs',
    navVoicemail: 'nav-voicemail',
    navSettings: 'nav-settings',
    navPbx: 'nav-pbx',
    navAudit: 'nav-audit',
    navTollFraud: 'nav-toll-fraud',
    navUsers: 'nav-users',
    navDocs: 'nav-docs',
    // DIDWW
    didwwApiKey: 'didww-api-key',
    didwwBaseUrl: 'didww-base-url',
    didwwSaveBtn: 'didww-save-btn',
    didwwTestBtn: 'didww-test-connection-btn',
    didwwRoutingMode: 'didww-routing-mode',
    didwwSyncDids: 'didww-sync-dids-btn',
    didwwSyncTrunks: 'didww-sync-trunks-btn',
    didwwSyncCdrs: 'didww-sync-cdrs-btn',
    // DIDs
    didTable: 'did-table',
    didCreateBtn: 'did-create-btn',
    didSaveBtn: 'did-save-btn',
    // Extensions
    extTable: 'extensions-table',
    extCreateBtn: 'extension-create-btn',
    extSaveBtn: 'extension-save-btn',
    // Call flows
    cfTable: 'callflows-table',
    cfCreateBtn: 'callflow-create-btn',
    cfSaveBtn: 'callflow-save-btn',
    // IVR
    ivrText: 'ivr-greeting-text',
    ivrVoice: 'ivr-voice',
    ivrGenerate: 'ivr-tts-generate-btn',
    ivrUpload: 'ivr-upload-btn',
    // Ring groups
    rgTable: 'ringgroups-table',
    rgCreateBtn: 'ringgroup-create-btn',
    rgSaveBtn: 'ringgroup-save-btn',
    // CDR
    cdrTable: 'calllogs-table',
    cdrExport: 'calllogs-export-csv-btn',
    // Voicemail
    vmTable: 'voicemail-table',
    // PBX
    pbxDownloadPjsip: 'pbx-download-pjsip-btn',
    pbxDownloadDialplan: 'pbx-download-dialplan-btn',
};

export default TID;
